import React from "react";
import TextInput from "../../../common/forms/input/TextInput";
import PropTypes from "prop-types";
import { FormGroup } from "reactstrap";
import FormItem from "../../../common/forms/FormItem";
import { Field } from "redux-form";
import { isRequired } from "../../../../utils/validators";

export const BusChassisFormFields = ({
    showEndointLabel,
    initialValues
}) => {

    return (
        <>
            <FormGroup row>
                <FormItem label="Nombre" required={[[isRequired]]}>
                    <Field
                        name="name"
                        component={TextInput}
                        type="text"
                        placeholder="Nombre"
                    />
                </FormItem>
            </FormGroup>
            <FormGroup row>
                <FormItem label="Descripción">
                    <Field
                        name="description"
                        component={TextInput}
                        type="textarea"
                        placeholder="Descripción"
                    />
                </FormItem>
            </FormGroup>
        </>
    );
}

BusChassisFormFields.propTypes = {
    showBusChassisLabel: PropTypes.bool,
    initialValues: PropTypes.shape({
    }),
};

BusChassisFormFields.defaultProps = {
    showBusChassisLabel: true,
    initialValues: null,
};

export default BusChassisFormFields;